(function () {
  'use strict';

  function initReveal(root) {
    if (!('IntersectionObserver' in window)) {
      root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    root.querySelectorAll('.reveal:not(.in)').forEach(function (el) { io.observe(el); });
  }

  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold || '700', 10);
    function onScroll() { if (window.scrollY > threshold) bar.classList.add('in'); else bar.classList.remove('in'); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initQty(root) {
    root.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input[name="quantity"]');
      var val = wrap.querySelector('.val');
      var dec = wrap.querySelector('[data-qty-dec]');
      var inc = wrap.querySelector('[data-qty-inc]');
      function set(n) {
        n = Math.max(1, parseInt(n, 10) || 1);
        if (input) input.value = n;
        if (val) val.textContent = n;
      }
      dec && dec.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
      inc && inc.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
    });
  }

  function initFaq(root) {
    root.querySelectorAll('[data-faq]').forEach(function (group) {
      var items = group.querySelectorAll('[data-faq-item]');
      items.forEach(function (item) {
        var btn = item.querySelector('[data-faq-q]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          if (group.dataset.faq === 'single') { items.forEach(function (i) { i.classList.remove('is-open'); }); }
          if (!open) item.classList.add('is-open');
          btn.setAttribute('aria-expanded', !open);
        });
      });
    });
  }

  function initUgc(root) {
    root.querySelectorAll('[data-ugc]').forEach(function (group) {
      var track = group.querySelector('[data-ugc-track]');
      group.querySelectorAll('[data-ugc-prev]').forEach(function (b) { b.addEventListener('click', function () { track && track.scrollBy({ left: -400, behavior: 'smooth' }); }); });
      group.querySelectorAll('[data-ugc-next]').forEach(function (b) { b.addEventListener('click', function () { track && track.scrollBy({ left: 400, behavior: 'smooth' }); }); });
    });
  }

  function initVariantPicker(root) {
    root.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      if (picker._lumeBound) return;
      picker._lumeBound = true;
      var data = {};
      try { data = JSON.parse(picker.querySelector('[data-variants-json]').textContent); } catch (e) { return; }
      var hideOos = picker.dataset.hideOos === 'true';
      var groups = picker.querySelectorAll('[data-option-group]');
      var form = document.querySelector('[data-product-form]');
      var idInput = form && form.querySelector('input[name="id"]');
      var priceEl = document.querySelector('[data-price-now]');
      var wasEl = document.querySelector('[data-price-was]');
      var atcLabel = document.querySelector('[data-atc-label]');
      var selectedValueLabels = picker.querySelectorAll('[data-option-value-for]');

      function getSelected() {
        var selected = {};
        groups.forEach(function (g) {
          var active = g.querySelector('.is-active');
          if (active) selected[g.dataset.optionGroup] = active.dataset.value;
        });
        return selected;
      }
      function findVariant(selected) {
        return data.variants.find(function (v) {
          return v.options.every(function (val, i) { return selected[data.option_names[i]] === val; });
        });
      }
      function recomputeAvailability() {
        var selected = getSelected();
        groups.forEach(function (g) {
          var optName = g.dataset.optionGroup;
          var optIdx = data.option_names.indexOf(optName);
          if (optIdx < 0) return;
          g.querySelectorAll('[data-variant-swatch]').forEach(function (sw) {
            var val = sw.dataset.value;
            var anyMatch = data.variants.some(function (v) {
              if (!v.available) return false;
              if (v.options[optIdx] !== val) return false;
              for (var i = 0; i < v.options.length; i++) {
                if (i === optIdx) continue;
                var name = data.option_names[i];
                if (selected[name] && selected[name] !== v.options[i]) return false;
              }
              return true;
            });
            sw.classList.toggle('is-soldout', !anyMatch);
            if (anyMatch) { sw.removeAttribute('aria-disabled'); sw.removeAttribute('hidden'); }
            else { sw.setAttribute('aria-disabled', 'true'); if (hideOos) sw.setAttribute('hidden', ''); }
          });
        });
      }
      function update() {
        var selected = getSelected();
        var v = findVariant(selected);
        if (v) {
          if (idInput) idInput.value = v.id;
          if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;
          if (wasEl && v.compare_at_formatted) wasEl.textContent = v.compare_at_formatted;
          if (atcLabel) atcLabel.textContent = v.available ? (atcLabel.dataset.add || 'Add to cart') : (atcLabel.dataset.soldout || 'Sold out');
          var atcBtn = document.querySelector('[data-atc]');
          if (atcBtn) atcBtn.disabled = !v.available;
          document.dispatchEvent(new CustomEvent('lume:variant', { detail: v }));
        }
        selectedValueLabels.forEach(function (el) {
          var optName = el.dataset.optionValueFor;
          for (var k in selected) {
            if (k.toLowerCase().replace(/\s+/g, '-') === optName) { el.textContent = selected[k]; break; }
          }
        });
        recomputeAvailability();
      }
      groups.forEach(function (g) {
        var swatches = g.querySelectorAll('[data-variant-swatch]');
        swatches.forEach(function (s) {
          s.addEventListener('click', function (e) {
            if (s.classList.contains('is-soldout') || s.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
            swatches.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); x.setAttribute('tabindex', '-1'); });
            s.classList.add('is-active'); s.setAttribute('aria-checked', 'true'); s.setAttribute('tabindex', '0');
            update();
          });
          s.addEventListener('keydown', function (e) {
            var list = Array.prototype.slice.call(swatches);
            var idx = list.indexOf(s);
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); for (var i = idx + 1; i < list.length; i++) { if (!list[i].hasAttribute('hidden')) { list[i].focus(); break; } } }
            else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); for (var j = idx - 1; j >= 0; j--) { if (!list[j].hasAttribute('hidden')) { list[j].focus(); break; } } }
          });
        });
      });
      update();
    });
  }

  function initCarousel(root) {
    root.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      if (carousel._lumeBound) return;
      carousel._lumeBound = true;
      var track = carousel.querySelector('[data-carousel-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
      if (slides.length === 0) return;
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-dot]'));
      var thumbs = Array.prototype.slice.call(carousel.querySelectorAll('[data-thumb]'));
      function scrollToIndex(i, smooth) {
        var idx = Math.max(0, Math.min(slides.length - 1, i));
        var slide = slides[idx]; if (!slide) return;
        var left = slide.offsetLeft - track.offsetLeft;
        try { track.scrollTo({ left: left, behavior: smooth === false ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft = left; }
      }
      function currentIndex() { var w = track.clientWidth || 1; return Math.round(track.scrollLeft / w); }
      function update() {
        var i = currentIndex();
        dots.forEach(function (d, idx) { var on = idx === i; d.classList.toggle('is-active', on); d.setAttribute('aria-selected', on ? 'true' : 'false'); });
        thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
        if (prevBtn) prevBtn.classList.toggle('is-disabled', i <= 0);
        if (nextBtn) nextBtn.classList.toggle('is-disabled', i >= slides.length - 1);
      }
      prevBtn && prevBtn.addEventListener('click', function () { scrollToIndex(currentIndex() - 1); });
      nextBtn && nextBtn.addEventListener('click', function () { scrollToIndex(currentIndex() + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { scrollToIndex(parseInt(d.dataset.dot, 10) || 0); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { scrollToIndex(parseInt(t.dataset.thumb, 10) || 0); }); });
      var scrollTimer;
      track.addEventListener('scroll', function () { clearTimeout(scrollTimer); scrollTimer = setTimeout(update, 60); }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); scrollToIndex(currentIndex() - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); scrollToIndex(currentIndex() + 1); }
      });
      document.addEventListener('lume:variant', function (e) {
        var v = e.detail; if (!v || !v.featured_media) return;
        var mid = v.featured_media.id;
        for (var i = 0; i < slides.length; i++) { if (parseInt(slides[i].dataset.mediaId, 10) === mid) { scrollToIndex(i); break; } }
      });
      update();
    });
  }

  function initAtc() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (typeof window.fetch !== 'function') return;
        e.preventDefault();
        var btn = form.querySelector('[data-atc]'); if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
        var fd = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { form.submit(); });
      });
    });
    document.querySelectorAll('[data-sticky-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (typeof window.fetch !== 'function') return;
        e.preventDefault();
        var fd = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { form.submit(); });
      });
    });
  }

  function initCountdown(root) {
    root.querySelectorAll('[data-countdown]').forEach(function (el) {
      var deadline = new Date(el.dataset.countdown).getTime(); if (isNaN(deadline)) return;
      function tick() {
        var diff = Math.max(0, deadline - Date.now());
        var d = Math.floor(diff / 86400000), h = Math.floor((diff % 86400000) / 3600000), m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
        var fmt = function (n) { return n < 10 ? '0' + n : '' + n; };
        el.querySelectorAll('[data-cd-d]').forEach(function (n) { n.textContent = fmt(d); });
        el.querySelectorAll('[data-cd-h]').forEach(function (n) { n.textContent = fmt(h); });
        el.querySelectorAll('[data-cd-m]').forEach(function (n) { n.textContent = fmt(m); });
        el.querySelectorAll('[data-cd-s]').forEach(function (n) { n.textContent = fmt(s); });
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function bind(root) {
    root = root || document;
    initReveal(root); initQty(root); initFaq(root); initUgc(root); initVariantPicker(root); initCarousel(root); initCountdown(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); initStickyAtc(); initAtc(); });
  } else { bind(); initStickyAtc(); initAtc(); }

  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  document.addEventListener('shopify:section:select', function (e) { bind(e.target); });
  document.addEventListener('shopify:block:select', function (e) { bind(e.target); });

  window.LumeProduct = { bind: bind };
})();
